import React from "react";

const AboutPalace = () => {
  return (
    <div className="about-1st-page ">
      <div className=" about-main row">
        <div className="about-1st-content col-lg-5 col-md-12">
          <div className="about-1st-heading">About The Surya Vilas Palace</div>
          <div className="about-1st-text">
            Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit
            sed semper vitae faucibus consequat. Sed dui auctor aliquam quam
            urna magna feugiat egestas placerat. Pharetra arcu nulla lacus
            molestie quis dignissim quis tempor interdum. Quam blandit iaculis
            ante pellentesque lectus viverra tristique ultrices. Adipiscing
            purus mattis leo sit mi id sed. Eleifend sed enim odio sapien
            tincidunt viverra. Interdum congue eu bibendum tellus odio.
            Ridiculus posuere ut id imperdiet lorem. Pellentesque turpis mi cras
            vel risus blandit elementum sed neque. Cursus mattis vulputate
            viverra viverra bibendum pharetra cursus. Lobortis pulvinar sed
            lacus vel lobortis. Venenatis nisl a tellus at leo sed eget egestas.
            Blandit ultrices vestibulum nisi lectus purus libero maecenas. At
            dolor amet diam nisl mauris gravida. Id in ut varius diam sed
            viverra viverra. Tincidunt neque vestibulum sociis iaculis lobortis
            eu pellentesque massa. Donec fermentum velit tellus libero enim ac
            tristique in. Aliquet vivamus curabitur cursus habitasse malesuada
            vitae ultrices eget. Dui vivamus quam pulvinar ut.
          </div>
        </div>
        <div className=" col-lg-7 col-md-12">
          <div className="about-img width-height ">
            <img
              className="about-1st-image relative"
              loading="lazy"
              src="/Assets/aboutplace-img.webp"
              alt="image_203"
            ></img>
            <img
              className="aboutpalace-logo"
              alt="logo"
              loading="lazy"
              src="/Assets/aboutpalace-logo1.webp  "
            ></img>
          </div>
        </div>
      </div>
      <img
        className="shape1"
        loading="lazy"
        alt="shapes"
        src="/Assets/Ellipse 62.webp"
      ></img>
      <img
        className="shape2"
        loading="lazy"
        alt="shapes"
        src="/Assets/Ellipse 61.webp"
      ></img>
      <img
        className="shape3"
        loading="lazy"
        alt="shapes"
        src="/Assets/Polygon 3.webp"
      ></img>
      <img
        className="shape4"
        loading="lazy"
        alt="shapes"
        src="/Assets/Ellipse 60.webp"
      ></img>
      <img
        className="shape5"
        loading="lazy"
        alt="shapes"
        src="/Assets/Polygon 3.webp"
      ></img>
    </div>
  );
};

export default AboutPalace;
